module.exports = __webpack_public_path__ + "static/media/ReportedProblems.3ca57fad.png";